import { useEffect } from 'react';

const MicrosoftAdsWrapper = ({ children, impressionUrl, trackMicrosoftAdImpressions, viewUrl }) => {
  useEffect(() => {
    trackMicrosoftAdImpressions({ impressionUrl, viewUrl });
  }, [impressionUrl, trackMicrosoftAdImpressions, viewUrl]);

  return children;
};

export default MicrosoftAdsWrapper;
